import React from 'react';
import { Copy } from '@honda-canada/design-system-react';
import themeStyles from './Accordions.styles';

const AccordionTitle = themeStyles.apply(Copy, 'AccordionTitle');

export const ACCORDION_TITLE_OFFSET_DESKTOP_HEIGHT = 178;
export const ACCORDION_TITLE_OFFSET_TABLET_HEIGHT = 158;
export const ACCORDION_TITLE_OFFSET_MOBILE_HEIGHT = 158;

/**
 * Creates a reusable title component for each Accordion item
 * @param {string} title - the accordion item label
 * @returns {node} - styled copy component to pass into accordion title
 */
const getAccordionTitle = title => <AccordionTitle>{title}</AccordionTitle>;

/**
 * Creates an array of items to pass into DSR accordion component
 * @param {node} accessories - Accessories component
 * @param {node} additionalWarranty - additional warranty component
 * @param {node} paymentSummary - payment summary component
 * @param {object} accordionItemLabels - object containing relevant title values
 * @returns {array} - the accordion items array to be passed into the component
 */
export const getAccordionItems = (accessories, additionalWarranty, paymentSummary, accordionItemLabels) => [
  {
    key: accordionItemLabels.accessoriesLabel,
    title: getAccordionTitle(accordionItemLabels.accessoriesLabel),
    content: accessories,
    roleLabel: 'none',
  },
  {
    key: accordionItemLabels.additionalWarrantyLabel,
    title: getAccordionTitle(accordionItemLabels.additionalWarrantyLabel),
    content: additionalWarranty,
    roleLabel: 'none',
  },
  {
    key: accordionItemLabels.paymentSummaryLabel,
    title: getAccordionTitle(accordionItemLabels.paymentSummaryLabel),
    content: paymentSummary,
    roleLabel: 'none',
  },
];
